import { IAgentSchema, IOfferSchema } from '@cian/api-models/offer-card/v1/get-offer-data';
import { Button } from '@cian/button-component';
import { MultilineTextField } from '@cian/components';
import * as React from 'react';

import { ComplaintBlockType, IAddComplaintOptions, IComplaint } from '../../../../../api/complaint';
import { Link } from '../../../../../common/components/link';
import { trackFeedbackComplainSelect } from '../../../tracking';
import * as styles from './index.css';

export interface IComplaintItemProps {
  step: number;
  agent: IAgentSchema | null;
  complaint: IComplaint;
  index: number;
  offer: IOfferSchema;
  isSelected: boolean;

  addComplaint(options: IAddComplaintOptions): void;
  onSelect(selected: number, isDropdown?: boolean): void;
}

export interface IComplaintItemState {
  errorDescription: string;
  errorTitle: string;
  message: string;
}

export class ComplaintItem extends React.PureComponent<IComplaintItemProps, IComplaintItemState> {
  public state = {
    errorDescription: '',
    errorTitle: '',
    message: '',
  };

  public render() {
    const { complaint, isSelected } = this.props;
    const { errorDescription, errorTitle, message } = this.state;

    return (
      <li className={styles['containter']}>
        {!isSelected && (
          <Link className={styles['name']} href="#" onClick={this.handleClickOnName}>
            {complaint.name}
          </Link>
        )}
        {isSelected && (
          <form onSubmit={this.handleSubmitTextForm}>
            <strong className={styles['selected-name']}>{complaint.name}</strong>
            <svg
              className={styles['selected-icon']}
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 13.994 9.499"
              width="14"
              height="10"
            >
              <path
                fill="#2B87DB"
                /* tslint:disable-next-line:max-line-length */
                d="M13.698.305c-.4-.404-1.052-.408-1.456-.008L5.447 7.01 1.76 3.24c-.396-.4-1.04-.406-1.444-.016-.41.394-.422 1.046-.028 1.456l4.41 4.51c.19.195.452.306.726.31h.01c.27-.002.53-.11.724-.3l7.53-7.44c.406-.4.41-1.05.01-1.455z"
              />
            </svg>
            <MultilineTextField
              containerStyle={styles['textarea']}
              onValueChange={this.handleChangeMessage}
              placeholder={complaint.hint}
              value={message}
            />
            {Boolean(errorTitle) && (
              <div className={styles['error']}>
                <strong className={styles['error-title']}>{errorTitle}</strong>
                {Boolean(errorDescription) && <p className={styles['error-description']}>{errorDescription}</p>}
              </div>
            )}
            <Button className={styles['button']} type="submit">
              Отправить жалобу
            </Button>
          </form>
        )}
      </li>
    );
  }

  private handleClickOnName = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();

    const { complaint, onSelect, index } = this.props;

    if (complaint.blockType !== ComplaintBlockType.Finish) {
      onSelect(index, complaint.blockType === ComplaintBlockType.Textarea);
    } else {
      this.submit();
    }
  };

  private submit = () => {
    const { step, addComplaint, complaint, offer } = this.props;

    trackFeedbackComplainSelect(step + 1, complaint.name);

    addComplaint({
      complaintId: complaint.id,
      message: this.state.message,
      offerRealtyId: offer.id,
    });
  };

  private handleSubmitTextForm = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    if (this.props.complaint.isCommentRequired && !this.state.message.trim()) {
      this.setState({
        errorDescription: 'Заполните текстовое поле',
        errorTitle: 'Ошибка отправки жалобы',
      });

      return;
    }

    this.submit();
  };

  private handleChangeMessage = (message: string) => {
    this.setState({
      errorDescription: '',
      errorTitle: '',
      message,
    });
  };
}
